import React, { useContext } from "react";
import { _LandingAboutRoot } from "./LandingAbout.styled";
import Typography from "../../../Foundation/Typography/Typography";
import { ImageResponsive, ImageUrlContext } from "../../Image";
import { ImageFit, ImageFormat } from "../../Image/interface/ImageData";
import HighlightedTypography from "../../HighlightedTypography/HighlightedTypography";
import htmlParse from "html-react-parser";
import clsx from "clsx";
import { isEmptyImageId } from "../../Image/Image.utils";

interface ILandingAboutProps {
  title: string;
  highlightedTitle?: string;
  description?: string;
  imageId?: string;
  backgroundImage?: {
    desktop?: string;
    mobile?: string;
  };
  imageRight?: boolean;
  withoutImage?: boolean;
}
const LandingAbout = (props: ILandingAboutProps) => {
  const {
    title,
    highlightedTitle,
    description,
    imageId,
    backgroundImage,
    imageRight,
    withoutImage = true,
  } = props;
  const { generateImageUrl } = useContext(ImageUrlContext);
  return (
    <_LandingAboutRoot
      id="landing-about"
      className="landing-about"
      $bg={{
        desktop:
          (backgroundImage &&
            backgroundImage.desktop &&
            !isEmptyImageId(backgroundImage.desktop) &&
            generateImageUrl({
              id: backgroundImage?.desktop || "-1",
              width: "auto",
              height: "auto",
              quality: 100,
              format: ImageFormat.WEBP,
            })) ||
          undefined,
        mobile:
          (backgroundImage &&
            backgroundImage.mobile &&
            !isEmptyImageId(backgroundImage.mobile) &&
            generateImageUrl({
              id: backgroundImage?.mobile || "-1",
              width: typeof window !== "undefined" ? window.innerWidth : "auto",
              height: "auto",
              quality: 90,
              format: ImageFormat.WEBP,
            })) ||
          undefined,
      }}
    >
      <div
        className={clsx("landing-about__container", {
          "image-right": imageRight,
          "without-image": withoutImage,
        })}
      >
        {!withoutImage && (
          <div className="landing-about__left landing-about__image">
            <div className="landing-about__image__cover">
              <ImageResponsive
                alt=""
                desktop={{
                  image: {
                    id: imageId,
                    fit: ImageFit.COVER,
                    quality: 80,
                    aspectRatio: 1,
                    width: 912,
                  },
                  imgStyle: {
                    overflow: "hidden",
                    aspectRatio: 1,
                    width: "100%",
                  },
                }}
                mobile={{
                  image: {
                    id: imageId,
                    fit: ImageFit.COVER,
                    quality: 100,
                    width: 382,
                    aspectRatio: 1,
                    outputPixelDensities: [1, 2],
                  },
                  imgStyle: {
                    overflow: "hidden",
                    aspectRatio: 1,
                    width: "100%",
                  },
                }}
              />
            </div>
          </div>
        )}

        <div className="landing-about__right">
          <div className="landing-about__description__container">
            <HighlightedTypography
              variant="h4"
              highlightedText={highlightedTitle}
              className="landing-about__title"
            >
              {title}
            </HighlightedTypography>
            <Typography variant={"body"} className="landing-about__description">
              {htmlParse(description + "")}
            </Typography>
          </div>
        </div>
      </div>
    </_LandingAboutRoot>
  );
};

export default LandingAbout;
